var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.183 90h-16v-8.07c-3.388-.488-6-3.408-6-6.93v-2c0-3.86 3.14-7 7-7h2v6h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v8h10v6ZM98.183 90h-11v-6h11a1 1 0 0 0 1-1V57.75l-9.878-18.487-.06-.145A4.979 4.979 0 0 0 84.612 36h-61.43c-2.757 0-5 2.242-5 5v22h-6V41c0-6.065 4.935-11 11-11h61.43c4.443 0 8.398 2.625 10.128 6.705l10.442 19.545V83c0 3.86-3.14 7-7 7ZM69.183 84h-24v6h24v-6Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.182 54H18v6h83.182v-6Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 36h-6v36h6V36ZM76.32 31.804l-5.502 2.392 10.43 23.999 5.503-2.392-10.43-23.999ZM24.183 66h-9v6h9v-6ZM66 36h-6v45h6V36ZM78 66h-9v6h9v-6ZM36.182 99c-6.617 0-12-5.382-12-12s5.383-12 12-12c6.618 0 12 5.382 12 12s-5.382 12-12 12Zm0-18c-3.307 0-6 2.692-6 6s2.693 6 6 6c3.308 0 6-2.692 6-6s-2.692-6-6-6ZM78.183 99c-6.618 0-12-5.382-12-12s5.382-12 12-12c6.617 0 12 5.382 12 12s-5.383 12-12 12Zm0-18c-3.308 0-6 2.692-6 6s2.692 6 6 6c3.307 0 6-2.692 6-6s-2.693-6-6-6Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.f06fc37a.svg";
export { ForwardRef as ReactComponent };